import React, { useContext, useEffect, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";


import { MdFamilyRestroom, MdNotificationsNone, MdCalendarMonth, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown, IoMdClose } from 'react-icons/io';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';
import { SiHandshake } from 'react-icons/si';
import { AiOutlineQuestionCircle, AiFillFolder, AiOutlinePlusCircle, AiOutlineSearch, AiOutlineTags } from 'react-icons/ai'


import { MdFilterListAlt } from "react-icons/md";
import { FaPeopleGroup } from 'react-icons/fa6';
import { FaRegCircle } from 'react-icons/fa';
import Renderif from '../../components/renderif';
import { useNavigate } from 'react-router-dom';
import SideMenu from '../../components/sidemenu';
import { IoIosArrowDown, IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'
import Quiz from '../../components/quiz';
import Calendar from 'react-calendar';
import BVCalendar from '../../components/calendar';
import Slider from '../../components/slider';
import { gray10, gray20, gray30, gray40, primary } from '../../utils/colors';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { AuthContext } from '../../context/auth_context';
import AlertNotification from '../../components/alert-notification';
import { Service } from '../../services/api';
import TipCard from '../../components/tipcard';
import CheckBox from '../../components/checkbox';
import { GoGear } from 'react-icons/go';

export default function TipsClient() {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const [state, setState] = useState({
    tab: 0,
    show_agendar_cita: false,
    show_onboarding: user.onboarding === "" || user.onboarding === null ? true : false,
    tips: [],
    tip_selected: null,
    search: '',
    tip_view: null,
  })

  useEffect(() => {
    const init = async () => {
      let tips = await Service('GET', `Tip?pageNumber=1&pageSize=20`);
      console.log(tips)
      setState({ ...state, tips: tips.data.data })
    };
    init();

    return () => { }
  }, [])



  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  const getVideo = (link) => {
    let video = 'https://www.youtube.com/watch?v=S8nTuZR059k';
    const urlSearchParams = new URLSearchParams(video);
    const params = Object.fromEntries(urlSearchParams.entries());

    let v = getParameterByName('v', link)
    return v
  }

  const filter = (tips) => {

    let filtered = tips.filter((item) =>
      item.description.toUpperCase().includes(state.search.toUpperCase()) ||
      item.title.toUpperCase().includes(state.search.toUpperCase())

    )


    return filtered
  }


  return (
    <div className='container-fluid d-flex h-100'>

      <SideMenu></SideMenu>





      <div className='container-fluid d-flex flex-column  h-100'>

        <div className='row'>

          <div className='d-flex flex-lg-row p-2 p-sm-3 bg-white border-b'>



            {/* FOTO PERFIL Y NOMBRE DEL USUARIO */}
            {/* <div className='d-flex align-items-center'>

<div className='avatar avatar--xl d-none d-xl-block cursor-pointer' onClick={()=>{
    setState({...state, show_select_profile:true})
}}></div>
<div className='avatar avatar--mid d-block d-xl-none cursor-pointer' onClick={()=>{
    setState({...state, show_select_profile:true})
}} ></div>

<div className='bold f-28 line-0 px-2 d-none d-xl-block'>¡Hola!, {user?.firstName} {user?.lastName}</div>
<div className='bold f-18 line-0 px-2 d-block d-xl-none'>¡Hola!, {user?.firstName} {user?.lastName}</div>

</div> */}
            <div className='d-flex align-items-center'>
              <div className='input--light-curve'>
                <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                <input placeholder='Busca Tips, Documentos, etc.'></input>
              </div>
            </div>
            <div className='col'></div>

            <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-end'>

              <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
                <div className='pe-2 cita-button flex-center'>
                  <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                    // setState({ ...state, show_agendar_cita: true })
                    navigate('/client/crear-cita')
                  }}>
                    <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                    Agendar cita
                  </div>
                </div>
                <div className='pe-2'>
                  <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                    if (state.notifications_menu) {
                      setState({ ...state, notifications_menu: false })
                    } else {
                      setState({ ...state, notifications_menu: true })
                    }

                  }}><MdNotificationsNone size={24} color={gray40}></MdNotificationsNone>
                    <Renderif isTrue={state.notifications_menu}>
                      <div className='float-menu'>
                        <div className='h-menu flex-center-left separator-h-bottom p-2'>
                          Notificaciones
                        </div>
                        <div className='b-menu'>
                          <div className='card-notification d-flex separator-h-top'>
                            <div className=''>
                              <div className='avatar-profile'></div>
                            </div>
                            <div className='flex-center f-12 p-2'>
                              Por el momento no cuenta con notificaciones
                            </div>
                          </div>
                          {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div> */}
                        </div>
                      </div>
                    </Renderif>
                  </div>
                </div>

                <div className='pe-2 me-4 agreements'>
                  <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                    if (state.agreements_menu) {
                      setState({ ...state, agreements_menu: false })
                    } else {
                      setState({ ...state, agreements_menu: true })
                    }

                  }}><FaPeopleGroup size={24} color={gray40}></FaPeopleGroup>
                    <Renderif isTrue={state.agreements_menu}>
                      <div className='float-menu'>
                        <div className='h-menu flex-center-left separator-h-bottom p-2'>
                          Acuerdos pendientes
                        </div>
                        <div className='b-menu'>
                          <div className='card-notification d-flex separator-h-top'>
                            <div className='flex-center ms-2'>
                              <FaRegCircle size={13} color={primary}></FaRegCircle>
                            </div>
                            <div className='flex-center f-12 p-2'>
                              Por el momento no cuenta con acuerdos
                            </div>
                          </div>
                          {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Hacer ejercicio
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Leer
                                                            </div>
                                                        </div> */}
                        </div>
                      </div>
                    </Renderif>
                  </div>
                </div>

                <div className='pe-2 px-md-2 flex-center separator-v-left cursor-pointer' onClick={() => {
                  if (state.profile_menu) {
                    setState({ ...state, profile_menu: false })
                  } else {
                    setState({ ...state, profile_menu: true })
                  }

                }}>
                  <div className='avatar-profile  ms-lg-3'></div>
                  <div className=''>
                    <IoIosArrowDown size={18} color={'#000000'}></IoIosArrowDown>

                  </div>

                </div>
                <Renderif isTrue={state.profile_menu}>
                  <div className='float-menu-profile'>
                    <div className='b-menu'>
                      <div className='card-notification flex-center-j-left m-2'>
                        <div className=''>
                          <div className='avatar-profile'></div>
                        </div>
                        <div className='p-2'>
                          <div className='bold f-14'>
                            {user?.firstName} {user?.lastName}
                          </div>
                          <div className='f-12 text-miperfil bold cursor-pointer' onClick={() => {
                            navigate('/client/profile')
                          }}>
                            Mi perfil
                            <IoIosArrowForward size={12} color={primary} className='ms-1'></IoIosArrowForward>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='b-menu'>
                      <div className='card-notification d-flex separator-h-top cursor-pointer'>
                        <div className='flex-center ms-2'>
                          <GoGear size={15} color={gray40}></GoGear>
                        </div>
                        <div className='flex-center f-12 p-2'>
                          Configuración
                        </div>
                      </div>
                      <div className='card-notification d-flex separator-h-top cursor-pointer' onClick={() => {
                        logout();
                        navigate('/')
                      }}>
                        <div className='flex-center ms-2'>
                          <CgLogOut size={15} color={gray40} />
                        </div>
                        <div className='flex-center f-12 p-2'>
                          Cerrar sesión
                        </div>
                      </div>
                    </div>
                  </div>
                </Renderif>
              </div>



            </div>


          </div>


          {/* <div className='p-1'>
    <Slider></Slider>
</div> */}


        </div>


        {/* MQUETA VIEJA */}
        {/* <div className='col h-75 d-flex '>

          <div className='col-3 overflow-auto hide-scroll bg-light px-4 '>

            <div className='d-flex align-items-center bg-white r-10 p-2'>
              <div className='f-16 text-gray'></div>
              <div className='col'></div>
              <DropDown
                title={''}
                icon={<MdFilterListAlt size={20} color={gray30}></MdFilterListAlt>}>

                <DropDownOption>
                  <div className='d-flex align-items-center px-2'>



                    <div className='text-dark f-16 bold'>Filtro</div>

                    <div className='col mx-5'></div>

                    <div className='bv-icon'><IoMdClose size={16} color={gray40}></IoMdClose></div>

                  </div>
                </DropDownOption>
                <DropDownOption disabled>
                  <div className='d-flex flex-column ps-2'>
                    <CheckBox checked={true} text="Asignados"></CheckBox>
                    <CheckBox checked={true} text="Nuevo"></CheckBox>
                    <CheckBox checked={true} text="Fecha Ascendente"></CheckBox>
                    <CheckBox checked={true} text="Fecha Descendente"></CheckBox>

                  </div>
                </DropDownOption>
                <DropDownOption>
                  <div className='d-flex align-items-center ps-2'>
                    <div className='col'></div>
                    <div className='f-14  bold text-blue'> Aplicar filtro</div>
                    <div className='bv-icon'><MdOutlineKeyboardArrowRight color={gray40}></MdOutlineKeyboardArrowRight></div>
                  </div>
                </DropDownOption>

              </DropDown>
            </div>
            {
              filter(state.tips)?.map((item, i) => {
                if (item.id === '9c1c02e2-1ac6-42da-b6a9-9aae4af8e89c') { return }

                return (<TipCard tag="Nuevo" key={i} tip={item} onClick={() => {
                  setState({ ...state, tip_selected: item })
                }}></TipCard>)
              })
            }

          </div>

          <div className='col-9 overflow-auto hide-scroll px-4 '>

            <div className='container'>


              <Renderif isTrue={state.tip_selected === null}>

                <div className='position-relative'>
                  <img width="100%" className='mx-auto' src='/assets/bannertips.png'></img>
                  <div className='position-absolute absolute-center-left ps-4 '>
                    <div className='f-30 bolder line-0'>Explora Nuestro Universo de <br></br> Bienestar y Psicología</div>
                    <br></br>
                    <div className='f-18'>En BienVivir, te ofrecemos una variedad de consejos y <br></br> recursos para fortalecer tu salud mental y tu bienestar. <br></br> Nuestra misión es brindarte herramientas valiosas para<br></br>  una vida más saludable y equilibrada.</div>
                  </div>
                </div>

              </Renderif>

              <Renderif isTrue={state.tip_selected !== null}>

                <div className='bv-card mt-4'>
                  <Renderif isTrue={state.tip_selected?.image !== null && getVideo(state.tip_selected?.video) === null}>
                    <div className='bv-card-img bv-card-img--full' style={{ backgroundImage: `url('${state.tip_selected?.image}')` }}></div>
                  </Renderif>

                  <Renderif isTrue={getVideo(state.tip_selected?.video) !== null}>
                    <iframe width="100%" height="415" src={`https://www.youtube.com/embed/${getVideo()}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                  </Renderif>

                  <div className='ps-2'>
                    <div className='f-16 bold text-gray p-1 pb-0 '>{state.tip_selected?.title}</div>
                    <div className='f-16 text-gray p-1'>{state.tip_selected?.description}</div>
                    <div className='my-5'></div>
                    <div className='d-flex align-items-end'>
                      <div className='f-12 bold text-blue p-1'>Tip #</div>
                      <div className='col'></div>
                      <div className={`text-white bg-purple bold f-12 px-3 py-1 my-1`}>¡Nuevo!</div>
                    </div>
                  </div>


                  <div className='px-2 py-2'>
                    <div className='bv-tag bv-tag--gray'>
                      <div className='bv-icon'><AiOutlineTags></AiOutlineTags></div>
                      <div className='text-gray pe-2'>Tip</div>
                    </div>
                    <div className='bv-tag bv-tag--gray'>
                      <div className='bv-icon'><AiOutlineTags></AiOutlineTags></div>
                      <div className='text-gray pe-2'>Bienvivir</div>
                    </div>
                  </div>
                </div>
              </Renderif>



              <div className='d-flex'>

              </div>

            </div>

          </div>




        </div> */}
        {/* MQUETA VIEJA */}

        {/* MQUETA NUEVA */}
        <Renderif isTrue={state.tab === 0}>
          <div className='d-flex bg-radial py-4'>
            <div className='col-sm-4 col-1'></div>
            <div className='txt-center col-sm-4 col-10'>
              <div className='h2 my-4'>
                Explora Nuestro Universo de Bienestar y Psicología
              </div>
              <div className='my-4'>
                En BienVivir, te ofrecemos una variedad de consejos y recursos para fortalecer tu salud mental y tu bienestar
              </div>
              <div className='flex-center'>
                <div className='float-search '>
                  <div className='input--light-curve bg-white'>
                    <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                    <input placeholder='Busca por tema de interes'></input>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-sm-4 col-1'></div>
          </div>
          <div className='d-flex my-4'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10 my-4 mx-sm-0 mx-2 col-12'>
              <div className='d-flex scrollmenu'>
                <div className='bv-cta-curve-small bv-cta--primary-black bv-icon bv-icon--mid m-2 txt-white'>Tips para tí</div>
                <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2 txt-white'>Salud mental</div>
                <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2 txt-white'>Estrés laboral</div>
              </div>
              <div className='grid-4 gap-4 my-4'>

                {
                  filter(state.tips)?.map((item, i) => {
                    if (item.id === '9c1c02e2-1ac6-42da-b6a9-9aae4af8e89c') { return }

                    return (
                      <div className='tip-card bv-card p-2 cursor-pointer' onClick={() => {
                        setState({ ...state, tab: 1, tip_view: item })
                      }}>
                        <div className='bold'>
                          {item.title}
                        </div>
                        <div className='tip-card-img' style={{ backgroundImage: `url('${item.image}')` }}>
                        </div>
                      </div>
                    )
                  })
                }



                {/* <div className='tip-card bv-card p-2'>
                <div className='bold'>
                  No reprimas tus emociones, eso puede hacer que se vuelvan más intensas
                </div>
                <div className='tip-card-img' style={{ backgroundImage: `url('https://bienvivir-static.s3.amazonaws.com/tips/5749808c-90d8-4590-ac6e-d656ef84167b.png')` }}>
                </div>
              </div>
              <div className='tip-card bv-card p-2'>
                <div className='bold'>
                  No reprimas tus emociones, eso puede hacer que se vuelvan más intensas
                </div>
                <div className='tip-card-img' style={{ backgroundImage: `url('https://bienvivir-static.s3.amazonaws.com/tips/5749808c-90d8-4590-ac6e-d656ef84167b.png')` }}>
                </div>
              </div>
              <div className='tip-card bv-card p-2'>
                <div className='bold'>
                  No reprimas tus emociones, eso puede hacer que se vuelvan más intensas
                </div>
                <div className='tip-card-img' style={{ backgroundImage: `url('https://bienvivir-static.s3.amazonaws.com/tips/5749808c-90d8-4590-ac6e-d656ef84167b.png')` }}>
                </div>
              </div>
              <div className='tip-card bv-card p-2'>
                <div className='bold'>
                  No reprimas tus emociones, eso puede hacer que se vuelvan más intensas
                </div>
                <div className='tip-card-img' style={{ backgroundImage: `url('https://bienvivir-static.s3.amazonaws.com/tips/5749808c-90d8-4590-ac6e-d656ef84167b.png')` }}>
                </div>
              </div>
              <div className='tip-card bv-card p-2'>
                <div className='bold'>
                  No reprimas tus emociones, eso puede hacer que se vuelvan más intensas
                </div>
                <div className='tip-card-img' style={{ backgroundImage: `url('https://bienvivir-static.s3.amazonaws.com/tips/5749808c-90d8-4590-ac6e-d656ef84167b.png')` }}>
                </div>
              </div> */}

              </div>
            </div>
            <div className='col-sm-1'></div>
          </div>
        </Renderif>
        {/* MQUETA NUEVA */}

        {/* TIP PREVIEW */}
        <Renderif isTrue={state.tab === 1}>
          <div className='d-sm-flex mt-4 '>
            <div className='col-sm-11 col-12'>
              <div className='row'>
                <div className='col-sm-2 col-0'>

                </div>
                <div className='col-sm-8 col-12 px-2 px-sm-0'>
                  <div className='d-flex'>
                    <div className='flex-center'>
                      <IoIosArrowBack size={24} className='m-3 cursor-pointer' onClick={() => {
                        setState({ ...state, tab: 0 })
                      }}></IoIosArrowBack>
                    </div>
                    <div>
                      <div>
                        14 de abril de 2024
                      </div>
                      <div className='h3'>
                        {state.tip_view?.title}
                      </div>
                    </div>
                  </div>

                  <div className='tip-card-detail-img my-3 ' style={{ backgroundImage: `url('${state.tip_view?.image}')` }}>
                  </div>

                  <div className='d-flex my-3 scrollmenu'>
                    <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2'>Etiqueta 1</div>
                    <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2'>Etiqueta 2</div>
                    <div className='bv-cta-curve-small bv-cta--primary-gray-20 bv-icon bv-icon--mid m-2'>Etiqueta 3</div>
                  </div>
                  <div>
                    {state.tip_view?.description}
                  </div>
                </div>
                <div className='col-sm-2 col-0'>

                </div>
              </div>
            </div>
            <div className='col-sm-2 col-12 mt-4 mt-sm-0 b-100 px-2 px-sm-0'>
              <div className='h4'>
                Te podría interesar
              </div>
              <div>
                {/* <div className='d-flex'>
                <div style={{ backgroundImage: `url('../../public/assets/tip1.png')` }}>
                </div>
                <div className='bold'>
                  Tomar 3 litros de agua al día
                </div>
              </div> */}

              </div>
            </div>
          </div>
        </Renderif>

        {/* TIP PREVIEW */}

      </div>

    </div>
  )
}
